import { useToast } from '@/app/_shared/components/ToastContext'
import { ToastType } from '@/app/_shared/enums'
import { type ActionReturnSuccessType, type ActionReturnType, hasActionFailed } from '@/app/_shared/types'
import { useTransition } from 'react'

export function useServerHandler() {
	const [isLoading, startTransition] = useTransition()
	const { pushToast } = useToast()

	/**
	 * @param action - The action to be executed. Must return a CRUD return promise that will be evaluated for errors.
	 * If need to perform a transition without executing any actions, just return a Promise.resolve() on the action.
	 */
	function doServerAction<T>(
		action: () => ActionReturnType<T>,
		onSuccess?: (response: ActionReturnSuccessType<T>) => void,
		onFail?: () => void,
	) {
		startTransition(() => {
			action()
				.then(res => {
					if (hasActionFailed(res)) {
						if (onFail) onFail()
						pushToast({ message: res.error, type: ToastType.ERROR })
						return
					}
					if (onSuccess) onSuccess(res)
				})
				.catch(() => {
					pushToast({ message: 'Internal server error', type: ToastType.ERROR })
					if (onFail) onFail()
				})
		})
	}

	return { isLoading, doServerAction }
}
